import Nav_Logo from "./Nav_Logo";
import Nav_Links from "./Nav_Links";
import { Link } from "react-router-dom";
import Nav_BtnTweet from "./Nav_BtnTweet";
import Nav_UserInfo from "./Nav_UserInfo";
import React from "react";

class Nav extends React.Component {
    render() {
        return(
            <div className="nav">
                <Link className="nav_link" to="/"><Nav_Logo /></Link>
                <Nav_Links />
                <Nav_BtnTweet />
                <Nav_UserInfo />
            </div>
        )
    }
}

export default Nav;